<template lang="html">
  <div class="sub-main column">
		<div class="sub-page column">
			  <section class="take-place column activity-container container-background">
					<div class='header-table row'>
						<div class='title'>
							Conseillers
						</div>
						<div class="attached-item row">
							<div class="phantom-flex"></div>
							<div class="ctn-cta">
								<div class="btn btn-red" @click="showAddConseiller = true">
									<span class="icon-form-plus"></span> Ajouter un conseiller
								</div>
							</div>
						</div>
					</div>
					<Table :elements="conseillers" :clickable="true" @statuschange="updateStatus" />
					<baseModal :show="showAddConseiller" @close="showAddConseiller = false" :content="contentModal" />
  			</section>
		</div>
  </div>
</template>

<style lang="scss">
</style>

<script>
import store from '@/store'
import {mapGetters} from 'vuex'
import ModalAddConseiller from './modals/ConseillerModal'
import baseModal from '@/common/components/baseModal'
import Table from './ConseillersTable'

export default {
	name: 'Conseillers',
	components: {
		Table,
		baseModal
	},
	beforeRouteEnter (to, from, next) {
		store.commit('LOADER_IN')
    store.dispatch('getConseillers')
    .then(() => {
			next()
    })
    .catch(() => {
			next(false)
    })
    .finally(() => {
			store.commit('LOADER_OUT')
    })
	},
	data () {
		return {
			showAddConseiller: false,
			contentModal: ModalAddConseiller
		}
	},
	methods: {
		updateStatus (e) {
      const {value, rowIndex} = e
      const id = this.conseillers[rowIndex].id
      const enable = !value
      store.commit('LOADER_IN')
      if (enable) {
        this.$store.dispatch('enableConseiller', id)
        .finally(() => {
          store.commit('LOADER_OUT')
        })
      } else {
        this.$store.dispatch('disableConseiller', id)
        .finally(() => {
          store.commit('LOADER_OUT')
        })
      }
		}
	},
	computed: {
		...mapGetters({
			conseillers: "conseillers"
		})
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?32f09457